<script setup lang="ts">
import Modal from "@/App/components/feedback/Modal.vue";
import { useFeedbackStore } from "@/App/stores";

const feedbackStore = useFeedbackStore();
</script>

<template>
  <Modal
    v-if="feedbackStore.show"
    :on-close="feedbackStore.close"
    :on-save="feedbackStore.save"
    :is-loading="feedbackStore.createFeedbackState.isLoading"
    :is-failed="feedbackStore.createFeedbackState.isFailed"
  />
</template>

<style scoped></style>
